import React, { useState } from "react";
import { Button, Grid, List, ListItem, ListItemText } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ListItemIcon from "@mui/material/ListItemIcon";
import useScrollToTop from "../../../components/CustomHooks/useScrollToTop";

function Confirm({ prevStep, goToStep, handleConfirm, values }) {
  useScrollToTop();

  const {
    tripid,
    permitNbr,
    portcd,
    speciescd,
    gearType,
    mgmtArea,
    neMultiFlg,
    brdstckArea,
  } = values;
  const [isDisabled, setIsDisabled] = useState(false);
  const selectedAreas = Object.keys(brdstckArea)
    .filter(function (keyName) {
      return brdstckArea[keyName];
    })
    .map(function (keyName) {
      return { area: keyName };
    });

  const _next = (event) => {
    event.preventDefault();
    const open_trip_hail = {
      offloading_port: portcd.id,
      speciescd: speciescd,
      sthrn_mgmt_area_flg: mgmtArea,
      gear_type: gearType,
      brdstck_area: selectedAreas,
      ne_multiflg: neMultiFlg,
    };
    setIsDisabled(true);
    handleConfirm(open_trip_hail);
  };

  const _cancel = (event) => {
    event.preventDefault();
    if (isDisabled) {
      setIsDisabled(false);
    }
    prevStep();
  };

  const handleClick = (step) => {
    goToStep(step);
  };

  return (
    <Grid container spacing={4} justifyContent="center" alignItems="center">
      <Grid item xs={12} md={5}>
        <List>
          <ListItem style={{ paddingLeft: "7px" }}>
            <ListItemText primary={`Vessel Permit: ${permitNbr}`} />
          </ListItem>
          <ListItem style={{ paddingLeft: "7px" }} divider>
            <ListItemText primary={`Trip Id: ${tripid}`} />
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(1)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText primary={`Port: ${portcd.name}`} />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(2)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText primary={`Fishery: ${speciescd}`} />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(2)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText
              primary={`Fishing in the Southern Management Area? ${
                mgmtArea === "true" ? "Yes" : "No"
              }`}
            />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(3)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText primary={`Gear Type: ${gearType}`} />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(4)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText
              primary={`Using a Northeast Multispecies Day-At-Sea? ${
                neMultiFlg === "true" ? "Yes" : "No"
              }`}
            />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
          <ListItem
            button
            onClick={() => handleClick(4)}
            style={{ paddingLeft: "7px" }}
            divider
          >
            <ListItemText
              primary={`Broadstock Areas: ${Object.entries(selectedAreas).map(
                ([key, data]) => {
                  return data.area === "GOMDA"
                    ? "Gulf of Maine"
                    : data.area === "INSHORE"
                    ? "Inshore Georges Bank"
                    : data.area === "SNEDA"
                    ? "Southern New England"
                    : "Offshore Georges Bank";
                }
              )}`}
            />
            <ListItemIcon style={{ minWidth: "0px" }}>
              <NavigateNextIcon />
            </ListItemIcon>
          </ListItem>
        </List>
      </Grid>
      <Grid container spacing={1} justifyContent="center" alignItems="center">
        <Grid item xs="auto">
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Grid>
        <Grid item xs="auto">
          <Button
            variant="contained"
            className={isDisabled ? "disabledBtn" : "successBtn"}
            disabled={isDisabled}
            onClick={_next}
          >
            Confirm and Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Confirm;
